import { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useFormContext } from "react-hook-form";
import { useLazyQuery } from "@apollo/client/react/hooks";
import { mapCartToForm } from "helpers/product";
import AdditionalSale from "../additionalSale/AdditionalSale";
import { GetUpsellOptions } from "../../../../helpers/api/cadeauConcepten/queries/products.gql";

function Upsell({ id, upsellRef, items }) {
    const [options, setOptions] = useState();
    const [resetUpsellOptions, setResetUpsellOptions] = useState(false);
    const { watch, getValues, reset } = useFormContext();
    const checkedName = id ? `${id}.upsell.checked` : `upsell.checked`;
    const checked = watch(checkedName);

    const [getUpsellOptions, { loading, data }] = useLazyQuery(
        GetUpsellOptions,
        {
            fetchPolicy: "cache-first", // Fetch from cache first
            variables: { slug: "lees-Cadeau" }
        }
    );

    const fetchUpsellOptions = useCallback(async () => {
        await getUpsellOptions();
        return data?.product?.upsell?.edges;
    }, [getUpsellOptions, data?.product?.upsell?.edges]);

    useEffect(() => {
        // Load upsell options when there the options is checked and there are no options
        if (checked && !options) {
            fetchUpsellOptions().then(result => {
                setOptions(result);
            });
        }
    }, [checked, options, items, fetchUpsellOptions]);

    useEffect(() => {
        // Reset values for cart item form
        if (items && options && id && !resetUpsellOptions) {
            const currentForm = getValues();
            const upsellItems = mapCartToForm(options, items);
            const updatedForm = {
                [id]: {
                    ...currentForm[id],
                    upsell: {
                        ...currentForm[id]?.upsell,
                        items: upsellItems
                    }
                }
            };
            reset(updatedForm);
            setResetUpsellOptions(true);
        }
    }, [getValues, reset, id, items, resetUpsellOptions, options]);

    return (
        <AdditionalSale
            title="Verras je ontvanger door een bijzondere fles wijn, thee of olijfolie bij je bestelling toe te voegen."
            type="upsell"
            loading={loading}
            items={options}
            id={id}
            ref={upsellRef}
        />
    );
}

Upsell.defaultProps = {
    id: undefined,
    items: undefined,
    upsellRef: undefined
};

Upsell.propTypes = {
    id: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({})),
    upsellRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.any })
    ])
};

export default Upsell;
